import Collection from "lib/collection";
import RefundModel from "../models/payments/refund";

export default Collection.extend({
    idAttribute: "_id",

    model: RefundModel,

    url: function () {
        return this.parent.url() + "/refund";
    },
});
